import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PREDEFINED_PRICING_TIERS_FEATURE_KEY } from '../keys';
import { PredefinedPricingTiersState } from '../reducers/predefined-pricing-tiers.reducer';

const selectState = createFeatureSelector<PredefinedPricingTiersState>(PREDEFINED_PRICING_TIERS_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state) => state.loaded);
export const selectLoading = createSelector(selectState, (state) => state.loading);
export const selectSaving = createSelector(selectState, (state) => state.saving);
export const selectSaved = createSelector(selectState, (state) => state.saved);
export const selectTiers = createSelector(selectState, (state) => state.tiers);
